import React, {useState, useEffect} from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import "./PersonalInfo.css";
import moment from "moment";

const PersonalInfo = ({ setPatientName, isCompanyAdmin, isSuperAdmin, permissions}) => {
  let {id} = useParams();
  const [userData, setUserData] = useState({});

  const cmToFeetAndInches = () => {
    const feet = Math.floor(userData.height / 30.48);
    const inchesCm = userData.height - feet * 30.48;

    const inches = Math.round(inchesCm / 2.54);

    return `${feet}'${inches}"`;
  };

  const kgToLbs = () => {
    const lbs = userData.weight * 2.20462;

    return `${Math.ceil(lbs)} lbs`;
  };

  useEffect(() => {
    if (id !== undefined) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/user_details", {id})
        .then((res) => {
          if (res.data.responseData) {
            let genderUpper = res.data.responseData.gender;
            let genderUpper2 = genderUpper.charAt(0).toUpperCase();
            let genderUpper3 = genderUpper.slice(1);
            let genderUpperF = genderUpper2 + genderUpper3;
            let data = {...res.data.responseData, gender: genderUpperF};
            setPatientName(res.data.responseData.patientName);
            setUserData(data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id, setPatientName]);
  return (
    <div className="patient_list_container personal_info_container">
      <div className="patient_card_title">
        <span>Personal Info</span>
        <span className="edit_pateint_details_link">
          {(permissions.update_file || isCompanyAdmin || isSuperAdmin) && <Link to={"/edit-patient-details/" + id}>Edit Details</Link>}
        </span>
      </div>
      <div className="patient_detail_title">Date of Birth</div>
      <div className="patient_detail_value">
        {userData.dateOfBirth ? moment(userData.dateOfBirth).format("L") : "-"}
      </div>
      <div className="patient_detail_title">City</div>
      <div className="patient_detail_value">
        {userData.city ? (userData.city !== "city" ? userData.city : "-") : "-"}
      </div>
      <div className="patient_detail_title">State</div>
      <div className="patient_detail_value">{userData.state ? userData.state : "-"}</div>
      <div className="patient_detail_title">Height</div>
      <div className="patient_detail_value">{userData.height ? 
      // cmToFeetAndInches()
      userData.height
      : "-"}</div>
      <div className="patient_detail_title">Weight</div>
      <div className="patient_detail_value">{userData.weight ? 
      // kgToLbs()
      userData.weight
      : "-"}</div>
      <div className="patient_detail_title">Gender</div>
      <div className="patient_detail_value">{userData.gender ? userData.gender : "-"}</div>
    </div>
  );
};

export default PersonalInfo;
